/**
 * 공지사항 기본정보(NOT_BASIC_01) 컬럼 정의
 * NOT_BASIC_01 화면 전용 컬럼 정의
 */

import { CreateColumn } from '../../../../Services/agGrid/createColumn';

const NOTICE_ROW_PASTEL_ORANGE = '#fff3e0';

const NOTICE_TYPE_LABELS = {
  0: '웹 / 앱',
  1: '웹',
  2: '앱',
};

const getPlainTextFromHtml = (html) => {
  if (!html) return '';

  const document = new DOMParser().parseFromString(String(html), 'text/html');
  return (document.body.textContent || '').replace(/\u00a0/g, ' ');
};

/** noticeYn === 'Y' 인 행 — 연한 주황 배경 */
export const getRowStyle1 = (params) => {
  const raw = params.data?.noticeYn ?? params.data?.NoticeYn ?? 'N';
  const yn = String(raw).trim().toUpperCase();
  if (yn === 'Y') {
    return { backgroundColor: NOTICE_ROW_PASTEL_ORANGE };
  }
  return null;
};

/**
 * 공지사항 기본정보 컬럼 정의 생성
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    // 회사코드 컬럼 (숨김)
    CreateColumn('coCd', '회사코드', 'left', 100, false, false, true, 'text', {
      minWidth: 100,
    }),
    // 회사 컬럼 (조건부 숨김)
    CreateColumn(
      'coNm',
      '회사',
      'left',
      150,
      false,
      false,
      props.userInfo?.authCd !== 'ADMIN',
      'text',
      {
        minWidth: 150,
      }
    ),
    // 공지여부 컬럼
    CreateColumn(
      'noticeYn',
      '공지여부',
      'center',
      120,
      false,
      false,
      true,
      'text',
      {
        minWidth: 120,
        valueFormatter: (params) => (params.value ? params.value : 'N'),
      }
    ),
    // 게시 환경 (ADMIN 설정, 목록 표시)
    CreateColumn(
      'noticeType',
      '게시 환경',
      'center',
      110,
      false,
      false,
      props.userInfo?.authCd !== 'ADMIN',
      'text',
      {
        minWidth: 100,
        valueFormatter: (params) => {
          const v = String(
            params.value ?? params.data?.NOTICE_TYPE ?? '0'
          ).trim();
          return NOTICE_TYPE_LABELS[v] ?? v;
        },
      }
    ),
    // 구분 컬럼 (숨김)
    CreateColumn('gubun', '구분', 'left', 100, false, false, true, 'text', {
      minWidth: 100,
    }),
    // 구분명 컬럼
    CreateColumn('gubunNm', '구분', 'left', 100, false, false, false, 'text', {
      minWidth: 100,
    }),
    // 구분 상세 컬럼
    CreateColumn(
      'gubunDtlNm',
      '구분 상세',
      'left',
      150,
      false,
      false,
      false,
      'text',
      {
        minWidth: 150,
      }
    ),
    // 제목 컬럼
    CreateColumn(
      'title',
      props.lanInfo?.length === 0
        ? ''
        : props.lanInfo?.find(
            (f) => f.lanType !== 'MENU' && f.lanId === 'Title'
          )?.lanNm || '제목',
      'left',
      100,
      false,
      false,
      false,
      'text',
      {
        minWidth: 100,
        flex: 1,
      }
    ),
    // 내용 컬럼 (길 경우 말줄임 ... 표시)
    CreateColumn('comment', '내용', 'left', 100, false, false, false, 'text', {
      minWidth: 100,
      flex: 1,
      valueFormatter: (params) => {
        const text = getPlainTextFromHtml(params.value);
        const maxLen = 50;
        if (text.length <= maxLen) return text;
        return text.slice(0, maxLen) + '...';
      },
    }),
    // 작성자 컬럼
    CreateColumn('name', '작성자', 'left', 150, false, false, false, 'text', {
      minWidth: 150,
    }),
    // 종료일 컬럼
    CreateColumn(
      'endDate',
      '종료일',
      'center',
      120,
      false,
      false,
      false,
      'date',
      {
        minWidth: 120,
        dateFormat: 'YYYY-MM-DD',
      }
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
  getRowStyle1,
};

export default columnDefs;
